export default __webpack_public_path__ + "static/media/success.dadf2188.svg";